// extracted by mini-css-extract-plugin
export default {"overlay":"SketchColorPicker_overlay__YDhZc","picker":"SketchColorPicker_picker__OoH5Z"};